import React from 'react';
import Wrapper from './MobileSaveInstrumentCheckbox.styles';
import Checkbox from '../checkbox/Checkbox';
import { ICheckbox } from '../SaveInstrumentCheckbox.types';

function MobileSaveInstrumentCheckbox({ classNamePrefix, value, onClick }: ICheckbox) {
  return (
    <Wrapper id="mobile-save-instrument-checkbox" onClick={onClick}>
      <Checkbox classNamePrefix={classNamePrefix} value={value} onClick={onClick} />
    </Wrapper>
  );
}
export default MobileSaveInstrumentCheckbox;
